import { setAccountId } from "@/lib/auth/account";
import { markSignedOut } from "@/lib/auth/sessionMarker";
import { apiPost } from "@/lib/http/client";

export async function logout(): Promise<void> {
  try {
    await apiPost<null>("/auth/logout", {});
  } catch {
    // Best-effort server revoke; client always signs out locally.
  } finally {
    markSignedOut();
    setAccountId(null);
  }
}
